import { SET_APP_STORE_INITIALIZED } from '../app/actions'
import { SET_RESOLVER_LOCATION } from '../resolver/actions'
import { isVideoOrSeries } from '../url/index'
import { replaceHistory } from '../navigation/actions'
import { setUpstreamContext } from './actions'
import { createUpstreamContext } from './index'
import {
  parseRecommIdFromQuery,
  stripRecommIdQueryParams,
  buildEmailRecommIdUpstreamContextData,
} from './email-recomm-id'

/**
 * @param {{ resolver: import('immutable').Map }} state
 * @returns {boolean}
 */
function shouldCaptureEmailRecommIdFromResolver (state) {
  if (!state || !state.resolver) {
    return false
  }
  const path = state.resolver.get('path') || ''
  const query = state.resolver.get('query')
  return Boolean(parseRecommIdFromQuery(query)) && isVideoOrSeries(path)
}

/**
 * @param {{ dispatch: Function, state: { resolver: import('immutable').Map } }} params
 * @returns {boolean} Whether capture ran
 */
function captureEmailRecommIdFromResolver ({ dispatch, state }) {
  if (!shouldCaptureEmailRecommIdFromResolver(state)) {
    return false
  }

  const { resolver } = state
  const path = resolver.get('path') || ''
  const query = resolver.get('query')
  const recommId = parseRecommIdFromQuery(query)
  const attribution = buildEmailRecommIdUpstreamContextData(recommId)

  dispatch(setUpstreamContext(createUpstreamContext({
    playEventData: attribution,
    mhTileData: attribution,
  })))

  dispatch(replaceHistory({
    url: path,
    query: stripRecommIdQueryParams(query),
    scrollToTop: false,
    timeout: 0,
  }))

  return true
}

/**
 * Capture Recombee email attribution when resolver location changes (client navigation).
 */
export function watchEmailRecommIdUpstreamContext ({ after }) {
  return after(SET_RESOLVER_LOCATION, async ({ dispatch, state }) => {
    captureEmailRecommIdFromResolver({ dispatch, state })
  }).when(({ state }) => shouldCaptureEmailRecommIdFromResolver(state))
}

/**
 * Capture on direct landing / refresh: resolver is hydrated from SSR without SET_RESOLVER_LOCATION.
 */
export function watchEmailRecommIdUpstreamContextOnBootstrap ({ after }) {
  return after(SET_APP_STORE_INITIALIZED, async ({ dispatch, state }) => {
    captureEmailRecommIdFromResolver({ dispatch, state })
  }).when(({ state }) => shouldCaptureEmailRecommIdFromResolver(state))
}
